import { render, staticRenderFns } from "./MovimientoCompraList.vue?vue&type=template&id=13b62af0&scoped=true&"
import script from "./MovimientoCompraList.vue?vue&type=script&lang=js&"
export * from "./MovimientoCompraList.vue?vue&type=script&lang=js&"
import style0 from "./MovimientoCompraList.vue?vue&type=style&index=0&id=13b62af0&scoped=true&lang=css&"
import style1 from "./MovimientoCompraList.vue?vue&type=style&index=1&id=13b62af0&lang=scss&scoped=true&"
import style2 from "./MovimientoCompraList.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b62af0",
  null
  
)

export default component.exports